import React from 'react';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="w-full h-[calc(100vh-80px)] flex flex-col items-center justify-center p-6 bg-background">
            <div className="max-w-md w-full text-center space-y-6 flex flex-col items-center">
                <div className="relative">
                    <div className="absolute inset-0 rounded-full bg-red-500/20 blur-xl animate-pulse"></div>
                    <div className="relative flex items-center justify-center w-24 h-24 rounded-3xl bg-red-100 dark:bg-red-900/30 border-2 border-red-500/20 shadow-sm">
                        <ShieldAlert className="w-12 h-12 text-red-600 dark:text-red-400" strokeWidth={1.5} />
                    </div>
                </div>
                
                <div className="space-y-2">
                    <h1 className="text-3xl font-bold tracking-tight text-foreground">Acceso Denegado</h1>
                    <p className="text-base text-muted-foreground max-w-sm mx-auto">
                        Tu rol actual no dispone de los permisos necesarios para visualizar esta página o realizar esta acción.
                    </p>
                </div>

                <div className="pt-6 border-t border-border w-full flex flex-col items-center gap-4">
                    <button
                        onClick={() => navigate('/dashboard')}
                        className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-all focus:ring-2 focus:ring-primary focus:ring-offset-2 active:scale-95 shadow-sm"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Volver al Dashboard
                    </button>
                    
                    <p className="text-xs text-muted-foreground">
                        Si creés que esto es un error, por favor contactá a tu administrador.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;
